import React from 'react';
import { SignatureCanvas } from './SignatureCanvas';
import { SignatureImage } from './SignatureImage';

export const Signature = ({ edit, ...props }) =>
  edit ? <SignatureCanvas {...props} /> : <SignatureImage {...props} />;
